import React from "react";
import newCalendarIcon from "../../../assets/images/acpCalenderIcon.svg";

const CalendarIcon = () => {
  return <img src={newCalendarIcon} alt="Calendar" />;
};

export default CalendarIcon;
